export const JobDetailsWalkthroughTooltip = {
  JobDetails: Symbol('JobDetails'),
  Departments: Symbol('Departments'),
  OfferStatus: Symbol('OfferStatus'),
  JobLocation: Symbol('JobLocation'),
};
export const ApplicationFormWalkthroughTooltip = {
  OpenQuestions: Symbol('OpenQuestions'),
  PersonalInformation: Symbol('PersonalInformation'),
  ApplyWithIndeed: Symbol('ApplyWithIndeed'),
};
export const ProcessWalkthroughTooltip = {
  Pipeline: Symbol('Pipeline'),
  ProfileFields: Symbol('ProfileFields'),
  AutoConfirmationEmail: Symbol('AutoConfirmationEmail'),
};
export const TeamWalkthroughTooltip = {
  AddTeamMember: Symbol('AddTeamMember'),
};

export enum CreateTalentPoolWalkthroughDialogResult {
  Cancel,
  EnableWalkthrough,
}

export enum TalentPoolCreatedDialogResult {
  BackToGettingStarted,
}

export enum DialogImages {
  Start = 'assets/images/onboarding/walkthrough/dialog-walkthrough-start.svg',
  Finish = 'assets/images/onboarding/walkthrough/dialog-walkthrough-end.svg',
}
